import styles from './LegalConsentModal.module.scss';
import React from 'react';
import { useIntl } from 'react-intl';
import { Button } from 'semantic-ui-react';
import cancelIcon from '../../../assets/cancelIcon.svg';

interface IConsentModalProps {
	modalHeader: string;
	consentMessage: string;
	showModal: boolean;
	handleDismiss: () => void;
	handleConsent: () => void;
}
const LegalConsentModal: React.FC<IConsentModalProps> = ({
	modalHeader,
	consentMessage,
	showModal,
	handleDismiss,
	handleConsent
}: IConsentModalProps) => {
	const intl = useIntl();

	return (
		<>
			{showModal && (
				<div className={styles.consentModalSection}>
					<div className={styles.consentModal}>
						<Button icon className={styles.consentCloseBtn} onClick={handleDismiss}>
							<img src={cancelIcon} className={styles.closeButton} alt="close" />
						</Button>
						<div className={styles.modalHeader}>{modalHeader}</div>
						<hr />
						<div className={styles.modalBody}>
							<div className={styles.modalContent}>{consentMessage}</div>
							<div className={styles.modalButton}>
								<Button
									type="button"
									success
									className={`${styles.closeBtn} ${styles.btn} fluid`}
									onClick={handleConsent}
								>
									{intl.formatMessage({ id: 'component:legalConsent:accept:button' })}
								</Button>
							</div>
							<div className={styles.consentText}>{intl.formatMessage({ id: 'component:legalConsent:consentText:text' })}</div>
						</div>
					</div>
				</div>
			)}
		</>
	);
};
export default LegalConsentModal;
